<template>
  <v-app id="inspire">
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="primary"
      dark
    >
<!--      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->

      <v-toolbar-title
        style="width: 350px"
      >
        <router-link v-bind:to="'/'" class="white--text" style="text-decoration: none"><v-icon>mdi-truck</v-icon>&nbsp;LIBRental</router-link>
      </v-toolbar-title>
      <!-- <v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down pl-10 ml-4"
      /> -->
      <v-spacer />
      <v-btn v-if="this.user == null" icon>
        <router-link v-if="isAdmin" v-bind:to="'/admin'" style="color: white; text-decoration: underline;position: relative; left: -30px;font-size: 10px;">Admin Login</router-link>
        <router-link v-else v-bind:to="'/login'" style="color: white; text-decoration: underline;font-size: 10px;">Login</router-link>
      </v-btn>
      
     <!-- <v-btn v-on="on" icon>
         <v-badge
          content="2"
          value="2"
          color="green"
          overlap
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn> -->
      <!-- <v-btn v-on="on" href="/cart" icon>
        <v-badge
          content="2"
          value="2"
          color="green"
          overlap
        >
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn> -->
    </v-app-bar>

     <v-content v-if="this.user != null">
      
      <v-bottom-navigation
        :value="activeBtn"
        color="primary"
        horizontal
      >
       
          <span class="v-btn" style='position: relative;'><table><tr><td>hi:</td><td style="color: green;">{{this.user}}</td></tr></table></span>
       

        <router-link v-bind:to="'/'" class="v-btn">
          <span>Home</span>
        </router-link>
       <!-- <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">
              <span>Shop</span>
            </v-btn>
          </template>
           <v-card
            class="mx-auto"
            max-width="344"
            outlined
          >

            <v-list-item
              v-for="(item, index) in items"
              :key="index"
              @click.prevent=""
              href="/shop"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>

          </v-card> 
        </v-menu>-->

        <router-link v-bind:to="'/Orders'" class="v-btn">
          <span>Orders</span>
        </router-link>

        <router-link v-bind:to="'/shop'" class="v-btn">
          <span>Shop</span>
        </router-link>

        <v-btn v-if="this.user != null" class="v-btn">
        <!--<v-icon>mdi-account-circle</v-icon>-->
        
        <a v-if="this.user != 'admin'" href="#" v-on:click.prevent="logout" style="color: blue; text-decoration: underline;">log out</a>
        
        <a v-else href="#" v-on:click.prevent="logoutadmin" style="color: blue; text-decoration: underline;">Sign out</a>
      </v-btn>

      </v-bottom-navigation>
    </v-content>

      <router-view/>
    
    <v-footer
      :padless="true"
    >
      <v-card
        flat
        tile
        width="100%"
        class="secondary white--text text-center"
      >
        <v-card-text>
          <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-home</v-icon>
          </v-btn>
          <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-email</v-icon>
          </v-btn>
          <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-calendar</v-icon>
          </v-btn>
           <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-delete</v-icon>
          </v-btn>

        </v-card-text>

        <v-card-text class="white--text pt-0">
          Lib Rental.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>LIBRental</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>
<script>
import firebase from 'firebase';

    export default {
        data () {
            return {
                items: [
                    { title: 'T-Shirts' },
                    { title: 'Jackets' },
                    { title: 'Shirts' },
                    { title: 'Jeans' },
                    { title: 'Shoes' },
                ],
                activeBtn: 1,
            }
        },
        methods:{

          logout: function(){
            firebase.auth().signOut();
            this.$store.dispatch('logOut');
            this.$store.dispatch('closeAll');
            this.$router.replace({ name: 'Home' });
            // this.$router.replace({ name: 'home' });
        },
        logoutadmin: function(){
            firebase.auth().signOut();
            this.$store.dispatch('logOut');
            this.$store.dispatch('closeAll');
            this.$router.replace({ name: 'admin' });
            // this.$router.replace({ name: 'home' });
        },

        },
        computed:{
          user(){
            return this.$store.state.user.username;
          },
           isAdmin() {
            return this.$route.name === 'admin'
          }
        },
       
    }
</script>
